module.exports = __webpack_public_path__ + "img/entrance_plant_5@3x.49501172.jpg";